import { render, staticRenderFns } from "./edit-review-modal.vue?vue&type=template&id=5c53f409&scoped=true"
import script from "./edit-review-modal.vue?vue&type=script&lang=js"
export * from "./edit-review-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-review-modal.vue?vue&type=style&index=0&id=5c53f409&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c53f409",
  null
  
)

export default component.exports